import Rellax from 'rellax';

export default {
    beforeMount(el, binding, vnode) {
        vnode.el.rellax = new Rellax(el, {
            ...binding.value || {
                speed: -2,
                percentage: 0.5,
            },
        });
    },

    updated(el, binding, vnode) {
        vnode.el.rellax.refresh();
    },

    beforeUnmount(el, binding, vnode) {
        vnode.el.rellax.destroy();
    },
};
